import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

const verifcationCodeMap = {
  0: 'unverified',
  1: 'verified',
  2: 'warning',
  3: 'error',
};

export const AddressValidationStatus = {
  id: 'addressValidationStatus',
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ShipToVerificationStatus',
  displayName: <FormattedMessage {...messages.addressValidationStatus} />,
  expectsArgumentAsArray: true,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations);
  },

  mapV2SavedFilterToV3Applied: (value) => ({
    criterionArgumentValue: verifcationCodeMap[value],
  }),
};
